import React from 'react';
import { IProps } from 'components/SliderAdvanced/Item/types';

const Item: React.FC<IProps> = (props) => {
  return (
    <div className="swiper-slide">
      {props.children}
    </div>
  );
};

export default Item;
